<template>
  <div class="inventory-container">
  <PageHeader title="انبار" infoTitle="راهنمای انبار" :infoLearnUrl="infoLearnUrl">
    <template #info>
      <p style="line-height:1.9; white-space:pre-line;">
        جهت ثبت ورودی کالاهای انبار از این قسمت میتوانید ورودی کالاها را ثبت نمایید. برای ثبت ورودی کالاها ابتدا دکمه جدید را زده سپس تحویل دهنده را مشخص نمایید و کالاهایی که تحویل گرفتید را از قسمت (جزئیات کالاهای ورودی) وارد کنید. در صورت نیاز میتوانید با زدن دکمه افزودن ردیف جدید کالاهای دیگری را به این قبض اضافه نمایید. در نهایت برای ثبت قبض بر روی دکمه (ثبت قبض) کلیک نمایید.
        جهت مشاهده فیلم و راهنمای کامل آموزشی بر روی لینک زیر کلیک نمایید.
      </p>
    </template>
  </PageHeader>
    <!-- تب‌های ورودی و خروجی -->
    <div class="inventory-tabs">
      <button 
        @click="activeTab = 'input'" 
        :class="['tab-button', { active: activeTab === 'input' }]"
      >
        ورودی
      </button>
      <button 
        @click="activeTab = 'output'" 
        :class="['tab-button', { active: activeTab === 'output' }]"
      >
        خروجی
      </button>
    </div>

    <!-- محتوای تب‌ها -->
    <div class="tab-content">
      <!-- تب ورودی -->
      <div v-if="activeTab === 'input'" class="input-tab">
        <div class="inventory-header">
          <div class="header-row">
            <!-- دکمه‌های جابجایی -->
            <div class="navigation-buttons">
              <button 
                @click="nextRecord('input')" 
                class="nav-btn nav-btn-right"
                :disabled="currentInputIndex >= totalInputRecords - 1"
                title="رکورد قبلی"
              >
                <ArrowRightSvg />
              </button>
              <span class="record-counter">
                {{ currentInputIndex + 1 }} از {{ totalInputRecords }}
              </span>
              <button 
                @click="previousRecord('input')" 
                class="nav-btn nav-btn-left"
                :disabled="currentInputIndex <= 0"
                title="رکورد بعدی"
              >
                <ArrowLeft />
              </button>
            </div>

            <!-- تاریخ -->
            <div class="form-group">
              <label for="input-date">تاریخ:<span class="required">*</span></label>
              <div class="p-date" style="width: 100% !important">
                <DatePicker
                  v-model="inputData.date"
                  format="jYYYY/jMM/jDD"
                  display-format="jYYYY/jMM/jDD"
                  :editable="true"
                  :clearable="false"
                  :auto-submit="true"
                  :show-now-btn="false"
                  placeholder="انتخاب تاریخ"
                  class="form-date-picker"
                  input-class="form-input"
                />
              </div>
            </div>

            <!-- شماره قبض -->
            <div class="form-group">
              <label for="input-invoice-number">شماره قبض:<span class="required">*</span></label>
              <input 
                id="input-invoice-number" 
                type="text" 
                v-model="inputData.invoiceNumber"
                class="form-input"
                placeholder="شماره قبض"
              />
            </div>

            <!-- نام پزشک -->
            <div class="form-group">
              <label for="input-doctor-select">نام پزشک:<span class="required">*</span></label>
              <select 
                id="input-doctor-select" 
                v-model="inputData.selectedDoctor" 
                class="form-select"
                @change="onDoctorChange('input')"
              >
                <option value="">انتخاب پزشک...</option>
                <option 
                  v-for="doctor in doctorsList" 
                  :key="doctor.id" 
                  :value="doctor"
                >
                  دکتر {{ doctor.firstName }} {{ doctor.lastName }}
                </option>
              </select>
            </div>

            <!-- تحویل دهنده -->
            <div class="form-group">
              <label for="input-deliverer">تحویل دهنده:<span class="required">*</span></label>
              <input 
                id="input-deliverer" 
                type="text" 
                v-model="inputData.deliverer"
                class="form-input"
                placeholder="نام تحویل دهنده"
              />
            </div>
          </div>
        </div>

        <!-- جدول کالاها -->
        <div class="inventory-content">
          <div class="inventory-form">
            <h3>جزئیات کالاهای ورودی</h3>
            
            <!-- جدول اقلام -->
            <BaseTable
              :items="inputData.items"
              :empty-colspan="6"
              :row-key="(row, idx) => idx"
            >
                <template #head>
                  <tr>
                    <th>ردیف</th>
                    <th>نام کالا</th>
                    <th>تعداد</th>
                    <th>مبلغ</th>
                    <th>جمع کل</th>
                    <th>عملیات</th>
                  </tr>
                </template>

                <template #row="{ item, index }">
                  <td data-label="ردیف">{{ index + 1 }}</td>

                  <td data-label="نام کالا">
                    <input
                      type="text"
                      v-model="item.name"
                      placeholder="نام کالا"
                    />
                  </td>

                  <td data-label="تعداد">
                    <input
                      class="table-borderless-input"
                      type="number"
                      v-model="item.quantity"
                      min="1"
                      @input="calculateItemTotal(index, 'input')"
                    />
                  </td>

                  <td data-label="مبلغ">
                    <input
                      class="table-borderless-input"
                      type="number"
                      v-model="item.price"
                      placeholder="قیمت"
                      @input="calculateItemTotal(index, 'input')"
                    />
                  </td>

                  <td data-label="جمع کل">{{ formatNumber(item.total || 0) }} ریال</td>

                  <td class="actions-cell" data-label="عملیات">
                    <BaseButton
                      title=""
                      hint="حذف ردیف"
                      variant="compact"
                      type="button"
                      aria-label="حذف ردیف"
                      @click.stop="removeItem(index, 'input')"
                    >
                      <template #icon>
                        <span aria-hidden="true">×</span>
                      </template>
                    </BaseButton>
                  </td>
                </template>

                <template #empty>
                  موردی برای نمایش وجود ندارد.
                </template>
            </BaseTable>

            <div class="table-actions">
              <BaseButton title="افزودن ردیف جدید" variant="secondary" type="button" @click="addItem('input')" />
            </div>

            <!-- جمع کل -->
            <div class="invoice-total">
              <div class="total-row">
                <span class="total-label">مجموع کل ورودی:</span>
                <span class="total-amount">{{ formatNumber(inputTotalAmount) }} ریال</span>
              </div>
            </div>

            <!-- توضیحات + دکمه‌های عملیات -->
            <div class="form-actions-row">
              <div class="form-group notes-group">
                <label for="input-notes">توضیحات:</label>
                <textarea 
                  id="input-notes" 
                  v-model="inputData.notes"
                  class="form-input"
                  placeholder="توضیحات ورودی"
                  rows="3"
                ></textarea>
              </div>
              <div class="actions-column">
                <div class="actions-row">
                  <BaseButton title="قبض جدید" variant="success" type="button" @click="resetInputForm">
                    <template #icon>
                      <span class="btn-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24"><path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                      </span>
                    </template>
                  </BaseButton>
                  <BaseButton title="حذف قبض" variant="danger" type="button" @click="deleteInputRecord">
                    <template #icon>
                      <span class="btn-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14M10 10v8m4-8v8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                      </span>
                    </template>
                  </BaseButton>

                  <BaseButton title="ابطال قبض" variant="outline-danger" type="button" @click="voidInputRecord">
                    <template #icon>
                      <span class="btn-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                      </span>
                    </template>
                  </BaseButton>
                </div>
                <div class="actions-row">
                  <span class="save-invoice-btn-wrap">
                    <BaseButton title="ثبت قبض" variant="primary" type="button" @click="saveInputRecord" :disabled="!canSaveInputRecord">
                      <template #icon>
                        <span class="btn-icon" aria-hidden="true">
                          <svg viewBox="0 0 24 24"><path d="M5 20h14a1 1 0 001-1V7l-4-4H6a1 1 0 00-1 1v16a1 1 0 001 1zm3-9h8m-8 4h5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                        </span>
                      </template>
                    </BaseButton>

                    <!-- allow disabled-state hint click, same pattern as clinic-invoice -->
                    <span
                      v-if="!canSaveInputRecord"
                      class="save-invoice-btn-overlay"
                      role="button"
                      aria-label="راهنمای تکمیل اطلاعات قبض"
                      tabindex="0"
                      @click="onDisabledSaveClick"
                      @keydown.enter.prevent="onDisabledSaveClick"
                      @keydown.space.prevent="onDisabledSaveClick"
                    ></span>
                  </span>

                  <BaseButton title="چاپ قبض" variant="outline-success" type="button" @click="printInputRecord">
                    <template #icon>
                      <span class="btn-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24"><path d="M7 17h10v4H7v-4zm10-6h-1V5H8v6H7a3 3 0 00-3 3v3h4v-2h8v2h4v-3a3 3 0 00-3-3z" fill="currentColor"/></svg>
                      </span>
                    </template>
                  </BaseButton>

                  <BaseButton title="تسویه" variant="secondary" type="button" @click="settleInputRecord">
                    <template #icon>
                      <span class="btn-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24"><path d="M20 7H4a2 2 0 00-2 2v6a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2zm-9 3h2a2 2 0 110 4h-2m0-4v4m9-5h.01M4 12h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                      </span>
                    </template>
                  </BaseButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- تب خروجی -->
      <div v-if="activeTab === 'output'" class="output-tab">
        <div class="inventory-header">
          <div class="header-row">
            <!-- دکمه‌های جابجایی -->
            <div class="navigation-buttons">
              <button 
                @click="nextRecord('output')" 
                class="nav-btn nav-btn-right"
                :disabled="currentOutputIndex >= totalOutputRecords - 1"
                title="رکورد قبلی"
              >
                <ArrowRightSvg />
              </button>
              <span class="record-counter">
                {{ currentOutputIndex + 1 }} از {{ totalOutputRecords }}
              </span>
              <button 
                @click="previousRecord('output')" 
                class="nav-btn nav-btn-left"
                :disabled="currentOutputIndex <= 0"
                title="رکورد بعدی"
              >
                <ArrowLeft />
              </button>
            </div>

            <!-- تاریخ -->
            <div class="form-group">
              <label for="output-date">تاریخ:<span class="required">*</span></label>
              <div class="p-date" style="width: 100% !important">
                <DatePicker
                  v-model="outputData.date"
                  format="jYYYY/jMM/jDD"
                  display-format="jYYYY/jMM/jDD"
                  :editable="true"
                  :clearable="false"
                  :auto-submit="true"
                  :show-now-btn="false"
                  placeholder="انتخاب تاریخ"
                  class="form-date-picker"
                  input-class="form-input"
                />
              </div>
            </div>

            <!-- شماره قبض -->
            <div class="form-group">
              <label for="output-invoice-number">شماره قبض:<span class="required">*</span></label>
              <input 
                id="output-invoice-number" 
                type="text" 
                v-model="outputData.invoiceNumber"
                class="form-input"
                placeholder="شماره قبض"
              />
            </div>

            <!-- نام پزشک -->
            <div class="form-group">
              <label for="output-doctor-select">نام پزشک:<span class="required">*</span></label>
              <select 
                id="output-doctor-select" 
                v-model="outputData.selectedDoctor" 
                class="form-select"
                @change="onDoctorChange('output')"
              >
                <option value="">انتخاب پزشک...</option>
                <option 
                  v-for="doctor in doctorsList" 
                  :key="doctor.id" 
                  :value="doctor"
                >
                  دکتر {{ doctor.firstName }} {{ doctor.lastName }}
                </option>
              </select>
            </div>

            <!-- تحویل دهنده -->
            <div class="form-group">
              <label for="output-deliverer">تحویل دهنده:<span class="required">*</span></label>
              <input 
                id="output-deliverer" 
                type="text" 
                v-model="outputData.deliverer"
                class="form-input"
                placeholder="نام تحویل دهنده"
              />
            </div>
          </div>
        </div>

        <!-- جدول کالاها -->
        <div class="inventory-content">
          <div class="inventory-form">
            <h3>جزئیات کالاهای خروجی</h3>
            
            <!-- جدول اقلام -->
            <BaseTable
              :items="outputData.items"
              :empty-colspan="6"
              :row-key="(row, idx) => idx"
            >
                <template #head>
                  <tr>
                    <th>ردیف</th>
                    <th>نام کالا</th>
                    <th>تعداد</th>
                    <th>مبلغ</th>
                    <th>جمع کل</th>
                    <th>عملیات</th>
                  </tr>
                </template>

                <template #row="{ item, index }">
                  <td data-label="ردیف">{{ index + 1 }}</td>

                  <td data-label="نام کالا">
                    <input
                      type="text"
                      v-model="item.name"
                      placeholder="نام کالا"
                    />
                  </td>

                  <td data-label="تعداد">
                    <input
                      class="table-borderless-input"
                      type="number"
                      v-model="item.quantity"
                      min="1"
                      @input="calculateItemTotal(index, 'output')"
                    />
                  </td>

                  <td data-label="مبلغ">
                    <input
                      class="table-borderless-input"
                      type="number"
                      v-model="item.price"
                      placeholder="قیمت"
                      @input="calculateItemTotal(index, 'output')"
                    />
                  </td>

                  <td data-label="جمع کل">{{ formatNumber(item.total || 0) }} ریال</td>

                  <td class="actions-cell" data-label="عملیات">
                    <BaseButton
                      title=""
                      hint="حذف ردیف"
                      variant="compact"
                      type="button"
                      aria-label="حذف ردیف"
                      @click.stop="removeItem(index, 'output')"
                    >
                      <template #icon>
                        <span aria-hidden="true">×</span>
                      </template>
                    </BaseButton>
                  </td>
                </template>

                <template #empty>
                  موردی برای نمایش وجود ندارد.
                </template>
            </BaseTable>

            <div class="table-actions">
              <BaseButton title="افزودن ردیف جدید" variant="secondary" type="button" @click="addItem('output')" />
            </div>

            <!-- جمع کل -->
            <div class="invoice-total">
              <div class="total-row">
                <span class="total-label">مجموع کل خروجی:</span>
                <span class="total-amount">{{ formatNumber(outputTotalAmount) }} ریال</span>
              </div>
            </div>

            <!-- توضیحات + دکمه‌های عملیات -->
            <div class="form-actions-row">
              <div class="form-group notes-group">
                <label for="output-notes">توضیحات:</label>
                <textarea 
                  id="output-notes" 
                  v-model="outputData.notes"
                  class="form-input"
                  placeholder="توضیحات خروجی"
                  rows="3"
                ></textarea>
              </div>
              <div class="actions-column">
                <div class="actions-row">
                  <BaseButton title="قبض جدید" variant="success" type="button" @click="resetOutputForm">
                    <template #icon>
                      <span class="btn-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24"><path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                      </span>
                    </template>
                  </BaseButton>
                  <BaseButton title="حذف قبض" variant="danger" type="button" @click="deleteOutputRecord">
                    <template #icon>
                      <span class="btn-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14M10 10v8m4-8v8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                      </span>
                    </template>
                  </BaseButton>

                  <BaseButton title="ابطال قبض" variant="outline-danger" type="button" @click="voidOutputRecord">
                    <template #icon>
                      <span class="btn-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                      </span>
                    </template>
                  </BaseButton>
                </div>
                <div class="actions-row">
                  <span class="save-invoice-btn-wrap">
                    <BaseButton title="ثبت قبض" variant="primary" type="button" @click="saveOutputRecord" :disabled="!canSaveOutputRecord">
                      <template #icon>
                        <span class="btn-icon" aria-hidden="true">
                          <svg viewBox="0 0 24 24"><path d="M5 20h14a1 1 0 001-1V7l-4-4H6a1 1 0 00-1 1v16a1 1 0 001 1zm3-9h8m-8 4h5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                        </span>
                      </template>
                    </BaseButton>

                    <span
                      v-if="!canSaveOutputRecord"
                      class="save-invoice-btn-overlay"
                      role="button"
                      aria-label="راهنمای تکمیل اطلاعات قبض"
                      tabindex="0"
                      @click="onDisabledSaveClick"
                      @keydown.enter.prevent="onDisabledSaveClick"
                      @keydown.space.prevent="onDisabledSaveClick"
                    ></span>
                  </span>

                  <BaseButton title="چاپ قبض" variant="outline-success" type="button" @click="printOutputRecord">
                    <template #icon>
                      <span class="btn-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24"><path d="M7 17h10v4H7v-4zm10-6h-1V5H8v6H7a3 3 0 00-3 3v3h4v-2h8v2h4v-3a3 3 0 00-3-3z" fill="currentColor"/></svg>
                      </span>
                    </template>
                  </BaseButton>

                  <BaseButton title="تسویه" variant="secondary" type="button" @click="settleOutputRecord">
                    <template #icon>
                      <span class="btn-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24"><path d="M20 7H4a2 2 0 00-2 2v6a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2zm-9 3h2a2 2 0 110 4h-2m0-4v4m9-5h.01M4 12h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                      </span>
                    </template>
                  </BaseButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <!-- Info handled by PageHeader -->
</template>

<script setup>
import BaseButton from '@/components/UiCompunents/BaseButton.vue'
import BaseTable from '@/components/UiCompunents/BaseTable.vue'
import PageHeader from '@/components/PageHeader.vue';
import { ref, computed, onMounted } from 'vue'
import { useDoctorsStore } from '@/stores/clinic/doctors'
import DatePicker from 'vue3-persian-datetime-picker'
import { useConfirm } from '@/stores/composables.js'
import moment from 'jalali-moment'
import ArrowLeft from '@/components/svgs/ArrowLeft.vue'
import ArrowRightSvg from '@/components/svgs/ArrowRightSvg.vue'

// Stores
const doctorsStore = useDoctorsStore()

// Tab state
const activeTab = ref('input')

// Navigation state for input
const currentInputIndex = ref(0)
const totalInputRecords = ref(1)

// Navigation state for output
const currentOutputIndex = ref(0)
const totalOutputRecords = ref(1)

// Input data
const inputData = ref({
  date: moment().format('jYYYY/jMM/jDD'),
  invoiceNumber: '',
  selectedDoctor: '',
  deliverer: '',
  notes: '',
  items: [
    {
      name: '',
      quantity: 1,
      price: 0,
      total: 0
    }
  ]
})

// Output data
const outputData = ref({
  date: moment().format('jYYYY/jMM/jDD'),
  invoiceNumber: '',
  selectedDoctor: '',
  deliverer: '',
  notes: '',
  items: [
    {
      name: '',
      quantity: 1,
      price: 0,
      total: 0
    }
  ]
})

// Computed properties
const doctorsList = computed(() => doctorsStore.doctorsList)

const canSaveInputRecord = computed(() => {
  return inputData.value.invoiceNumber && 
         inputData.value.selectedDoctor &&
         inputData.value.deliverer
})

const canSaveOutputRecord = computed(() => {
  return outputData.value.invoiceNumber && 
         outputData.value.selectedDoctor &&
         outputData.value.deliverer
})

const inputTotalAmount = computed(() => {
  return inputData.value.items.reduce((sum, item) => {
    return sum + (item.total || 0)
  }, 0)
})

const outputTotalAmount = computed(() => {
  return outputData.value.items.reduce((sum, item) => {
    return sum + (item.total || 0)
  }, 0)
})

// Methods
const nextRecord = (type) => {
  if (type === 'input') {
    if (currentInputIndex.value < totalInputRecords.value - 1) {
      currentInputIndex.value++
      console.log('بارگیری رکورد ورودی بعدی:', currentInputIndex.value)
    }
  } else {
    if (currentOutputIndex.value < totalOutputRecords.value - 1) {
      currentOutputIndex.value++
      console.log('بارگیری رکورد خروجی بعدی:', currentOutputIndex.value)
    }
  }
}

const previousRecord = (type) => {
  if (type === 'input') {
    if (currentInputIndex.value > 0) {
      currentInputIndex.value--
      console.log('بارگیری رکورد ورودی قبلی:', currentInputIndex.value)
    }
  } else {
    if (currentOutputIndex.value > 0) {
      currentOutputIndex.value--
      console.log('بارگیری رکورد خروجی قبلی:', currentOutputIndex.value)
    }
  }
}

const onDoctorChange = (type) => {
  if (type === 'input') {
    console.log('پزشک ورودی انتخاب شده:', inputData.value.selectedDoctor)
  } else {
    console.log('پزشک خروجی انتخاب شده:', outputData.value.selectedDoctor)
  }
}

const saveInputRecord = () => {
  if (!canSaveInputRecord.value) {
    alert('لطفاً تمام فیلدهای اجباری را پر کنید')
    return
  }

  const record = {
    ...inputData.value,
    type: 'input',
    createdAt: moment().format('jYYYY/jMM/jDD HH:mm:ss')
  }

  console.log('رکورد ورودی ثبت شده:', record)
  alert('رکورد ورودی با موفقیت ثبت شد')
}

const saveOutputRecord = () => {
  if (!canSaveOutputRecord.value) {
    alert('لطفاً تمام فیلدهای اجباری را پر کنید')
    return
  }

  const record = {
    ...outputData.value,
    type: 'output',
    createdAt: moment().format('jYYYY/jMM/jDD HH:mm:ss')
  }

  console.log('رکورد خروجی ثبت شده:', record)
  alert('رکورد خروجی با موفقیت ثبت شد')
}

const { confirm } = useConfirm()
const deleteInputRecord = async () => {
  if (!inputData.value.invoiceNumber) {
    alert('شماره قبض نامعتبر است')
    return
  }
  const confirmed = await confirm('آیا از حذف این رکورد ورودی مطمئن هستید؟')
  if (!confirmed) return
  console.log('حذف رکورد ورودی:', inputData.value.invoiceNumber)
  alert('رکورد ورودی حذف شد')
}

const deleteOutputRecord = async () => {
  if (!outputData.value.invoiceNumber) {
    alert('شماره قبض نامعتبر است')
    return
  }
  const confirmed = await confirm('آیا از حذف این رکورد خروجی مطمئن هستید؟')
  if (!confirmed) return
  console.log('حذف رکورد خروجی:', outputData.value.invoiceNumber)
  alert('رکورد خروجی حذف شد')
}

const printInputRecord = () => {
  console.log('چاپ رکورد ورودی:', inputData.value.invoiceNumber)
  alert('رکورد ورودی چاپ شد')
}

const printOutputRecord = () => {
  console.log('چاپ رکورد خروجی:', outputData.value.invoiceNumber)
  alert('رکورد خروجی چاپ شد')
}

const settleInputRecord = () => {
  console.log('تسویه رکورد ورودی:', inputData.value.invoiceNumber)
  alert('رکورد ورودی تسویه شد')
}

const settleOutputRecord = () => {
  console.log('تسویه رکورد خروجی:', outputData.value.invoiceNumber)
  alert('رکورد خروجی تسویه شد')
}

const voidInputRecord = () => {
  console.log('ابطال رکورد ورودی:', inputData.value.invoiceNumber)
  alert('قبض ورودی باطل شد')
}

const voidOutputRecord = () => {
  console.log('ابطال رکورد خروجی:', outputData.value.invoiceNumber)
  alert('قبض خروجی باطل شد')
}

const addItem = (type) => {
  const item = {
    name: '',
    quantity: 1,
    price: 0,
    total: 0
  }
  
  if (type === 'input') {
    inputData.value.items.push(item)
  } else {
    outputData.value.items.push(item)
  }
}

const removeItem = (index, type) => {
  if (type === 'input') {
    if (inputData.value.items.length > 1) {
      inputData.value.items.splice(index, 1)
    }
  } else {
    if (outputData.value.items.length > 1) {
      outputData.value.items.splice(index, 1)
    }
  }
}

const calculateItemTotal = (index, type) => {
  if (type === 'input') {
    const item = inputData.value.items[index]
    item.total = (item.quantity || 0) * (item.price || 0)
  } else {
    const item = outputData.value.items[index]
    item.total = (item.quantity || 0) * (item.price || 0)
  }
}

const formatNumber = (number) => {
  return new Intl.NumberFormat('fa-IR').format(number)
}

const resetInputForm = () => {
  inputData.value = {
    date: moment().format('jYYYY/jMM/jDD'),
    invoiceNumber: '',
    selectedDoctor: '',
    deliverer: '',
    notes: '',
    items: [
      {
        name: '',
        quantity: 1,
        price: 0,
        total: 0
      }
    ]
  }
}

const resetOutputForm = () => {
  outputData.value = {
    date: moment().format('jYYYY/jMM/jDD'),
    invoiceNumber: '',
    selectedDoctor: '',
    deliverer: '',
    notes: '',
    items: [
      {
        name: '',
        quantity: 1,
        price: 0,
        total: 0
      }
    ]
  }
}

// Lifecycle
onMounted(async () => {
  await doctorsStore.fetchDoctors()
  
  // تولید شماره قبض خودکار
  inputData.value.invoiceNumber = `INV-IN-${Date.now()}`
  outputData.value.invoiceNumber = `INV-OUT-${Date.now()}`
  
  // تنظیم تاریخ امروز
  inputData.value.date = moment().format('jYYYY/jMM/jDD')
  outputData.value.date = moment().format('jYYYY/jMM/jDD')
})

// Info modal state & methods
// Info modal state handled by PageHeader
const infoLearnUrl = 'https://www.sinapardazesh.ir/matab-learning-web/'
// openInfoModal handled by PageHeader
</script>

<style scoped>
:root {
  --text-color-secondary: #6b7280;
  --text-color-secondary-rgb: 107, 114, 128;
  --background-color-button-rgb: 20, 116, 242;
}

.inventory-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
  direction: rtl;
  text-align: right;
}

/* space below page header */
.inventory-container > .header {
  margin-bottom: 0;
}

/* تب‌ها */
.inventory-tabs {
  display: flex;
  margin-bottom: 20px;
  border-bottom: 2px solid var(--text-color-secondary);
}

.tab-button {
  padding: 12px 24px;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  font-size: 16px;
  font-weight: 500;
  color: var(--text-color-secondary);
  cursor: pointer;
  transition: all 0.3s ease;
}

.tab-button:hover {
  color: var(--background-color-button);
  background-color: var(--background-color-secondary);
}

.tab-button.active {
  color: var(--background-color-button);
  border-bottom-color: var(--background-color-button);
  background-color: var(--background-color-secondary);
}

.tab-content {
  background: var(--background-color);
  /* border: 1px solid var(--text-color-secondary); */
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 2px 4px rgba(var(--text-color-secondary-rgb), 0.1);
}

/* هدر انبار */
.inventory-header {
  background: var(--background-color-secondary);
  border: 1px solid var(--text-color-secondary);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(var(--text-color-secondary-rgb), 0.1);
}

.header-row {
  display: grid;
  grid-template-columns: auto 1fr 1fr 1fr 1fr;
  gap: 20px;
  align-items: end;
}

/* داخل جدول (BaseTable): فیلدهای تعداد/مبلغ بدون بُردر */
.table-borderless-input {
  border: 0 !important;
  outline: none;
  box-shadow: none;
  background: transparent;
}

.table-borderless-input:focus {
  border: 0 !important;
  outline: none;
  box-shadow: none;
}

@media (max-width: 1024px) {
  .header-row {
    grid-template-columns: 1fr 1fr;
    gap: 15px;
  }
}

@media (max-width: 768px) {
  .header-row {
    grid-template-columns: 1fr;
    gap: 15px;
  }
}

.navigation-buttons {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
}

.nav-btn {
  width: 40px;
  height: 40px;
  border: 1px solid var(--background-color-button);
  background: var(--background-color);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.nav-btn:hover:not(:disabled) {
  background: var(--background-color-button);
  color: var(--text-color-forthly);
}

.nav-btn:disabled {
  border-color: var(--text-color-secondary);
  color: var(--text-color-secondary);
  cursor: not-allowed;
}

.record-counter {
  font-size: 12px;
  color: var(--text-color-secondary);
  white-space: nowrap;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-weight: 600;
  color: var(--text-color-primary);
  font-size: 14px;
}

.form-group label .required {
  color: #dc3545;
  margin-right: 3px;
  font-weight: bold;
}

.form-select,
.form-input {
  padding: 8px 10px;
  border: 1px solid var(--text-color-secondary);
  border-radius: 6px;
  font-size: 14px;
  text-align: right;
  direction: rtl;
  background: var(--background-color);
  color: var(--text-color-primary);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-select {
  cursor: pointer;
}

.form-select:focus,
.form-input:focus {
  outline: none;
  border-color: var(--background-color-button);
  box-shadow: 0 0 0 0.2rem rgba(var(--background-color-button-rgb), 0.25);
}

.inventory-content {
  margin-bottom: 20px;
}

.inventory-form h3 {
  margin-bottom: 20px;
  color: var(--text-color-primary);
  padding-bottom: 10px;
}

.table-actions {
  margin-top: 10px;
  margin-bottom: 20px;
}

.invoice-total {
  border-top: 1px solid var(--text-color-secondary);
  padding-top: 15px;
  margin-bottom: 25px;
}

.total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
}

.total-amount {
  color: var(--text-color-primary);
}

.inventory-form {
  background: var(--background-color);
  border: 1px solid var(--text-color-secondary);
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(var(--text-color-secondary-rgb), 0.1);
}

.notes-group {
  flex: 1;
}

.form-input {
  padding: 8px 10px;
  border: 1px solid var(--text-color-secondary);
  border-radius: 6px;
  font-size: 14px;
  text-align: right;
  direction: rtl;
  background: var(--background-color);
  color: var(--text-color-primary);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  width: 100%;
  resize: vertical;
  min-height: 40px;
}

.form-input:focus {
  outline: none;
  border-color: var(--background-color-button);
  box-shadow: 0 0 0 0.2rem rgba(var(--background-color-button-rgb), 0.25);
}

.form-actions-row {
  display: grid;
  grid-template-columns: 1fr 1fr; /* راست: توضیحات | چپ: دکمه‌ها */
  gap: 20px;
  align-items: end;
}

.actions-column {
  display: grid;
  grid-auto-rows: min-content;
  gap: 12px;
}

.actions-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(120px, 1fr));
  gap: 12px;
  justify-items: stretch;
}

.actions-row .btn {
  width: 100%;
}

/* BaseButton in the actions grid should behave like .btn (full-width, centered label) */
.actions-row :deep(.base-button) {
  width: 100%;
  justify-content: center;
}

.save-invoice-btn-wrap {
  position: relative;
  display: inline-block;
  width: 100%;
}

.save-invoice-btn-overlay {
  position: absolute;
  inset: 0;
  cursor: pointer;
  background: transparent;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
}

.btn-primary {
  background-color: var(--background-color-button);
  color: var(--text-color-forthly);
}

.btn-primary:hover:not(:disabled) {
  background-color: var(--background-color-button-hover);
}

.btn-primary:disabled {
  background-color: var(--text-color-secondary);
  cursor: not-allowed;
}

.btn-secondary {
  background-color: var(--background-color-button2);
  color: var(--text-color-primary);
}

.btn-secondary:hover {
  background-color: var(--background-color-button-hover2);
}

.btn-info {
  background-color: var(--background-color-button);
  color: var(--text-color-forthly);
}

.btn-info:hover {
  background-color: var(--background-color-button-hover);
}

.btn-danger {
  background-color: #dc3545;
  color: #fff;
}

.btn-danger:hover {
  background-color: #c82333;
}

.btn-success {
  background-color: var(--background-color-button);
  color: var(--text-color-forthly);
}

.btn-success:hover {
  background-color: var(--background-color-button-hover);
}

.btn .btn-icon {
  display: inline-flex;
  width: 18px;
  height: 18px;
  margin-left: 6px;
  vertical-align: middle;
}

.btn .btn-icon svg {
  width: 18px;
  height: 18px;
}

.p-date {
  border: 1px solid var(--text-color-secondary);
  border-radius: 10px;
  text-align: start;
  overflow: hidden;
  background-color: var(--background-color);
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.p-date :deep(.vpd-container) {
  border: 1px solid rgba(var(--text-color-secondary-rgb), 0.12);
  border-radius: 0.75rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  background-color: var(--background-color);
}

.p-date :deep(.vpd-input-group label) {
  background-color: var(--background-color-button) !important;
}

.p-date :deep(.vpd-input-group input) {
  border: none !important;
  line-height: 32px !important;
  background-color: var(--background-color) !important;
  color: var(--text-color-primary) !important;
}

.p-date :deep(.vpd-input-group input::placeholder) {
  color: var(--text-color-secondary) !important;
  opacity: 1;
}

.p-date :deep(.vpd-input-group input:focus) {
  border: 1px solid transparent !important;
}

.p-date :deep(.vpd-icon-btn),
.p-date :deep(button.vpd-icon-btn),
.p-date :deep(.vpd-actions button) {
  background-color: var(--background-color-button) !important;
  color: var(--background-color) !important;
  transition: background-color 0.3s ease !important;
}

.p-date :deep(.vpd-icon-btn svg),
.p-date :deep(button.vpd-icon-btn svg),
.p-date :deep(.vpd-actions button svg),
.p-date :deep(.vpd-icon-btn svg path),
.p-date :deep(button.vpd-icon-btn svg path),
.p-date :deep(.vpd-actions button svg path) {
  fill: var(--background-color) !important;
  color: var(--background-color) !important;
  stroke: var(--background-color) !important;
}

.p-date :deep(.vpd-icon-btn:hover),
.p-date :deep(button.vpd-icon-btn:hover),
.p-date :deep(.vpd-actions button:hover) {
  background-color: var(--background-color-button-hover) !important;
}

.p-date :deep(.vpd-addon-list) {
  background: var(--background-color) !important;
  border: 1px solid var(--text-color-secondary) !important;
}

.p-date :deep(.vpd-addon-list-item) {
  color: var(--text-color-primary) !important;
}

.p-date :deep(.vpd-addon-list-item:hover) {
  background: var(--background-color-secondary) !important;
}

.p-date :deep(.vpd-picker-container) {
  background: var(--background-color) !important;
  border: 1px solid var(--text-color-secondary) !important;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .form-actions-row {
    grid-template-columns: 1fr; /* stack: notes on top, actions below */
    align-items: stretch;
  }
  .actions-column {
    align-self: stretch;
    display: grid;
    grid-template-columns: repeat(2, minmax(120px, 1fr));
    gap: 12px;
  }
  /* Flatten both rows into one grid so we get 3 rows x 2 columns */
  .actions-column .actions-row {
    display: contents;
  }
}

@media (max-width: 420px) {
  .actions-column {
    grid-template-columns: repeat(2, minmax(100px, 1fr));
  }
}

@media print {
  .navigation-buttons,
  .form-actions-row {
    display: none;
  }
  
  .inventory-container {
    padding: 0;
    box-shadow: none;
  }
  
  .inventory-header,
  .inventory-content {
    border: none;
    box-shadow: none;
  }
}
</style>